import { fetchPostWeb } from 'eco-design-micro/request2/FetchClient';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';

export const subscribeFn = async (email: string, source: string, locale?: string, subscribeData?: any) => {
    const sendDataA = subscribeData
        ? {
              eventTracking: subscribeCookie(subscribeData),
              email,
              source,
          }
        : {
              email,
              source,
          };
    const resA = await fetchPostWeb(`/website/subscribe`, sendDataA, {
        locale: locale || 'us',
    });
    return resA;
};
